import {hr} from "./hr";

export const it: { [key in keyof typeof hr]: string } = {
    ...hr,
    "external-accounts": "Account collegati",
    "mcp-api-keys": "Chiavi API MCP",
    showAdDate: "Mostra inserimento data documento",
    isBackgroundInstallable: "Installazione in background",
    minPantheonBuildNo: "Build Pantheon min",
    maxPantheonBuildNo: "Build Pantheon max",
    pantheonBuildConstraintsInfoTitle: "Vincoli build Pantheon",
    pantheonBuildConstraintsInfo:
        "Si usano le ultime 4 cifre del numero di build (es. 4600). Lascia vuoto per offrire sempre il gruppo.",
    marservis_workorders_ending_soon:
        "Radni nalozi koji završavaju unutar 5 dana",
    itemName: "Artikl",
    projectName: "Projekt",
    subjectName: "Subjekt",
    documentNumber: "Broj dokumenta",
    workDate: "Datum rada",
    work_orders_overview: "Pregled",
    Warehouse: "Skladište",
    List: "Pregled dokumenata",
    UnfinishedDocuments: "Nedovršeni dokumenti",
    FIXED_ASSETS: "Osnovna sredstva",
    MARSERVIS_USER_WORK_ORDERS: "Radni nalozi",
    "work-attachments": "Prilozi poslova",
    "writing-response-internal-communication": "Nova interna poruka",
    "add-internal-communication": "Dodaj internu poruku",
    "users-with-access": "Kontrola pristupa",
    forBilling: "Za naplatu",
    "work-hours": "Sati rada",
    FixedAssets: "Osnovna sredstva",
    skipConfirmationOnShortcuts:
        "Skoči direktno na izradu krajnjeg dokumenta (umjesto prikaza detalja izvornog dokumenta)",
    pickingShowConfirmationOnPick:
        "Prikaži poruku da je dostignuta potrebna količina",
    healthchecks_dashboard: "Healthchecks",
    transformation: "Transformacija",
    fromId: "Od",
    toId: "Na",
    WorkOrdersReception: "Radni nalozi - prijem",
    WorkOrdersOperative: "Radni nalozi - operativa",
    Orders: "Narudžbe",
    Approvals: "Odobrenje",
    DeliveryNotesControl: "Kontrola otpremnice",
    DeliveryNotesFromOrder: "Otpremnica iz narudžbe",
    InvoiceDeliveryNotes: "Račun iz otpremnice",
    LURInvoice: "Račun - Lučka uprava rovinj",
    MarservisUserWorkOrders: "Korisnički radni nalozi - Marservis",
    DeliveryNotes: "Otpremnice",
    acWorkPlace: "Radno mj.",
    acFiscalDevice: "Fiskalni ur.",
    Copy: "Kopiranje",
    wiki_local: "Local wiki",
    wiki: "Wiki",
    "delete-support-todo": "obrisati ovaj podsjetnik?",
    "no-team-viewer-sessions": "Nema TeamViewer sesija",
    "total-time-on-teamviewer": "Ukupno vrijeme TeamViewer",
    "delete-support-time-log": "obrisati ovo vrijeme rada?",
    todos: "Podsjetnici",
    duration: "Trajanje",
    startDate: "Početak",
    endDate: "Kraj",
    userId: "Utente",
    deviceName: "Naziv uređaja",
    deviceId: "ID uređaja",
    supportTicketTimeLogId: "Vrijeme rada",
    supportTicketId: "Tiket",
    update: "Ažuriraj",
    "want-to-close-without-billable-time-log-or-unassigned-team-viewer-sessions":
        "nastaviti bez naplativog vremena rada ili s TeamViewer sesijama koje nemaju povezano vrijeme rada?",
    "want-to-close-with-unassigned-team-viewer-sessions":
        "Želite li nastaviti s TeamViewer sesijama koje nemaju vrijeme rada?",
    "editing-team-viewer-session": "Editing TeamViewer session",
    "adding-new-team-viewer-session": "Adding TeamViewer session",
    team_viewer_sessions: "TeamViewer",
    "expense-bearer-changed-since-adding-to-this-document":
        "Job number changed, click here to recalculate per diems and currency rates.",
    adminUseAnWsPrice: "Koristi AnWsPrice prije ostalih",
    adminShowDailyIncome: "Prikaži zaključak blagajne",
    articleSearchShowOnlyWhereAcFieldsAIs:
        "Prikaži artikle tamo gdje je AcFieldsA",
    articleSearchAllowSearchingByClassification:
        "Prikaži filter po klasifikaciji prije liste idenata",
    adminUseGenericDocumentsForMoveAndOrder:
        "Koristi generičku izradu dokumenata za THeMove i THeOrder",
    adminSendDocumentToCompanyDocumentEmail:
        "Šalji sažetak dokumenta na Email poduzeća",
    adminIgnoreRebate1: "Ne koristi rabat 1",
    adminIgnoreRebate2: "Ne koristi rabat 2",
    adminIgnoreRebate3: "Ne koristi rabat 3",
    "department-items": "Department items",
    workOrder: "Work order",
    "automatic-logout": "Automatic logout",
    system: "System",
    "general-settings": "General settings",
    workOrderStatus: "Work order status",
    "mark-as-not-finished": "Mark as not finished",
    WorkOrderInitials: "WO",
    itemGroup: "Grupa",
    "Ne postoji ova veza artikla i grupe":
        "This article and group are not connected",
    workOrderDate: "Datum radnog naloga",
    totalWorkTime: "Ukupno vrijeme rada",
    "item-groups": "Article groups",
    "add-to-customer": "Add to customer",
    "connect-project": "Connect project",
    "The DateEnd field is required.": "Pick an end date",
    "The ProjectId field is required.": "Pick a project",
    transmissionSerialNumber: "Transmission serial number",
    engineSerialNumber: "Engine serial number",
    hinNumber: "HIN number",
    "mark-as-finished": "Označi kao odrađeno",
    InProgress: "U radu",
    "total-hours": "Total hours",
    "department-overview": "Department",
    "connect-item": "Connect item",
    "add-to-group": "Add to group",
    "item-group-overview": "Group",
    billableTime: "Billable hours",
    "work-order-open": "Work order open",
    workOrderId: "Work order ID",
    itemGroupName: "Group",
    "new-entry": "New entry",
    "without-group": "Without group",
    "picking-article-group": "Pick an article group",
    "add-all-items-from-group": "Add articles from group",
    hasAccess: "Access",
    "adding-user-to-file-permissions": "Add new user",
    "you-want-to-delete-this-file": "delete this file?",
    permissions: "Permissions",
    "date-changed-do-you-want-to-recalculate-down-payment-conversion":
        "Do you want to recalculate the down payment conversion rate to use selected date?",
    experiments: "Eksperimenti",
    "download-pdf": "Download PDF",
    "open-pdf": "Open PDF",
    creating: "Creating",
    updating: "Updating",
    "not-finished": "Not finished",
    reading: "Deleting",
    deactivated: "Deactivated",
    "A task must have responsible agent": "A task must have responsible agent",
    "task-end-date": "End date",
    deleting: "Deleting",
    uploading: "Uploading",
    saving: "Saving",
    "there-was-an-error": "There was an error",
    "try-again": "Please try again",
    "drop-files-for-upload": "Drop files for upload",
    "drop-some-files-or-click-to-select":
        "Drag some files here or click to select them",
    "adding-file": "Adding document",
    "editing-file": "Editing document",
    "document-details": "Document details",
    "delete-document": "this document?",
    itemGroupId: "Article group",
    departmentId: "Article department",
    Hangfire: "Hangfire",
    Swagger: "Swagger",
    GraphQL: "GraphQL",
    department: "Department",
    "item-group": "Item group",
    "editing-item-group": "Editing item group",
    "adding-item-group": "Adding item group",
    "adding-department": "Adding a department",
    "editing-department": "Editing a department",
    "server-downtimes": "Server downtime",
    "do-you-want-to-apply-new-conversion-for-currency":
        "Do you want to update the currency conversion? From {conversionFrom} {currency} to {conversionTo} {currency}",
    "codebooks-departments": "Departments",
    "codebooks-item-groups": "Article groups",
    item_groups: "Article groups",
    departments: "Departments",
    OpenTasks: "Open tasks",
    "save-and-close": "Save and close",
    "save-and-set-status": "Save and set \"{{status}}\"",
    model: "Model",
    engineModel: "Engine",
    transmissionModel: "Transmission",
    "adding-sql-template": "Adding SQL template",
    "editing-sql-template": "Editing SQL template",
    sql_templates: "SQL templates",
    editing_packet: "Editing packet",
    firstName: "Name",
    lastName: "Surname",
    userName: "Username",
    companySettingsId: "Company",
    companySettings: "Company",
    ForReview: "Review",
    "undock-sidebar": "Undock sidebar",
    "dock-sidebar": "Dock sidebar",
    "spam-emails": "Spam emails",
    "adding-spam-email": "Adding spam email",
    "editing-spam-email": "Editing spam email",
    "save-task": "Save task",
    "add-task": "Add task",
    "writing-response-task": "Adding a new task",
    grouping: "Grouping",
    attachments: "Attachments",
    "grouping-settings-notice":
        'Grouping is only applied to currently visible items, to apply grouping to all items, use "Show all items" button.',
    "show-paginated": "Show paginated",
    "show-all-items": "Show all items",
    "rest-of-the-groups": "Other groups",
    pantheonId: "Pantheon ID",
    "active-groups": "Active groups",
    groups: "Groups",
    "grouping-settings": "Grouping settings",
    "toggle-status": "Toggle status",
    Done: "Done",
    NotDone: "Not done",
    Invoiced: "Invoiced",
    temporaryOwner: "Agent",
    expenseBearer: "Job number",
    true: "Yes",
    false: "No",
    all: "All",
    isDone: "Finished",
    applicationUser: "Worker",
    Users: "Users",
    Workers: "Workers",
    Contacts: "Contacts",
    Projects: "Projects",
    CompanySettings: "Databases",
    TicketMessages: "Ticket messages",
    Tickets: "Tickets",
    Companies: "Companies",
    "id-or-pantheonid": "Web or Pantheon ID",
    "money-accounts": "Money accounts",
    "customer-accounts": "Customer accounts",
    "supplier-accounts": "Supplier accounts",
    "add-account": "Adding account",
    "edit-account": "Editing account",
    "are-you-sure-you-want-to-delete": "Are you sure you want to delete '{0}'?",
    "business-analysis-accounts": "Accounts",
    account: "Account",
    "business-analysis-settings": "Business analysis settings",
    "add-money-account": "Adding money account",
    "edit-money-account": "Editing money account",
    pantheon_key: "Pantheon key",
    onix_key: "Onix key",
    synchronized: "Synchronized",
    not_synchronized: "Not synchronized",
    costBearer: "Cost bearer",
    costBearerName: "Cost bearer name",
    day: "Day",
    costType: "Cost type",
    pantheonCostGroup: "Pantheon cost type",
    pantheonCostGroupName: "Pantheon cost type group",
    pantheonCostType: "Pantheon cost type",
    pantheonWorker: "Pantheon worker",
    workHours: "Work hours",
    workMinutes: "Work minutes",
    workRecordCostType: "Cost type",
    workerId: "Worker Id",
    downloads: "Downloads",
    "adding-new-company-document": "Adding new company document",
    "editing-company-document": "Editing company document",
    fileId: "Document",
    customer: "Customer",
    warehouseOverviewShowOnlyInStock: "Prikaži samo dostupno",
    articleSearchShowOnlyInStock: "Prikaži samo dostupno",
    articleSearchInitiallyLoadAll: "Učitaj sve kod otvaranja",
    articleSearchRepeatLastSearch: "Ponovi prethodno pretraživanje",
    itemListShowDetailed: "Prikaži više detalja",
    documentOnCreateMakePdf: "Izradi PDF novog dokumenta",
    documentOnCreateMakeBluetoothPrint:
        "Ispiši novi dokument na Bluetooth printer ",
    stockViewLoadAllOnOpen: "Učitaj sve kod otvaranja",
    stockViewShowOnlyInStock: "Prikaži samo dostupno",
    addingItemWarnIfQuantityMoreThanAvailable:
        "Upozori ako je količina veća od dostupne",
    bluetoothPrintCopiesNumber: "Broj kopija",
    cacheDuration: "Trajanje (min)",
    cacheUseCacheForAnyResource: "Predmemorija za sve resurse",
    cacheUseForArticleSearch: "Za artikle",
    cacheUseForCustomerSearch: "Za kupce",
    cacheUseForWarehouseSearch: "Za skladište",
    adminDocumentOnCreateMakeWarehouseReservation:
        "Izradi rezervaciju na skladištu",
    adminAllowChangingItemPrice: "Dopusti promijenu cijene",
    adminItemQuantityMustBeInStock: "Količina ne smije biti veća od dostupne",
    adminCanEditDocumentAfterSaving: "Omogući uređivanje nakon spremanja",
    adminUseSerialNumberForItems: "Koristi serijske brojeve za stavke",
    adminDeleteItemsAfterDocumentIsSaved:
        "Omogući brisanje stavaka nakon spremanja",
    "bluetooth-printer": "Bluetooth printer",
    document: "Dokument",
    items: "Stavke",
    "adding-items": "Dodavanje stavki",
    "codebooks-items": "Articles",
    "adding-item": "Adding article",
    "editing-item": "Editing article",
    materials: "Materials",
    "marservis-user-work-orders": "Work orders",
    jobs: "Jobs",
    "adding-work-order-job": "Adding work order job",
    "editing-work-order-job": "Editing work order job",
    itemId: "Article",

    "admin-settings": "Administrator settings",
    warehouseName: "Warehouse",
    functionality: "Functionality",
    "users-old-and-new-notice":
        "Old users and new users use the same users but user-level settings are different, use old users for Onix Phone < 9.1.1",
    "users-old": "Users old",
    "users-new": "Users new",
    "admin-users-v2": "Users new",
    "want-to-delete-item": "delete this row?",
    "contact-has-no-companies": "Il contatto non ha aziende",
    "saved-filters": "Filtri salvati",
    "apply-filter": "Applicare filtro",
    "created-on-date": "Creato su data",
    "not-selected": "Non impostato",
    id: "Id",
    "modified-on-date": "Modificato in data",
    "due-date": "Data di scadenza",
    "Pantheon AcConfrm is not 'T' and AcStatus is not 'Otvoren'":
        "Pantheon AcConfrm non è 'T' e AcStatus non è 'Otvoren'.",
    "there-was-an-error-while-syncing":
        "Si è verificato un errore durante la sincronizzazione",
    "time-of-return": "Ora di ritorno",
    "time-of-departure": "Orario di partenza",
    "The CostTypeId field is required.": "Scegli un tipo di costo",
    "The Currency field is required.": "Scegli una valuta",
    "The CurrencyId field is required.": "Scegli una valuta",
    "The Date field is required.": "Scegli una data",
    "The ExpenseBearerId field is required.": "Scegli un numero di lavoro",
    "The Value field is required.": "Inserire un valore",
    "Travel start date time must be before travel end time":
        "Deve essere prima del ritorno",
    "Travel start meter must be less than travel end meter":
        "Deve essere meno che terminare",
    "Travel warrant is closed": "Il mandato di viaggio è chiuso",
    "add-time-log": "Aggiungi registrazione del tempo",
    "added-note": "Nota aggiunta",
    testing: "Verifica",
    "adding-new-personal-vehicle": "Aggiunta di nuovo veicolo personale",
    "adding-travel-warrant-item": "Aggiunta di spese",
    "close-travel-warrant": "Stretto mandato di viaggio",
    "contact-companies": "Società  di contatto",
    "contact-emails": "Email di contatto",
    "cost-type": "Tipo di costo",
    "date-of-departure": "Data di partenza",
    "date-of-return": "Data di ritorno",
    "document-id": "Chiave del documento",
    "edit-other-personal-vehicles": "Modifica altri veicoli personali",
    "edit-travel-warrant-item": "Modifica spese",
    "editing-new-personal-vehicle": "Modifica del nuovo veicolo personale",
    "editing-travel-warrant-item": "Modifica delle spese",
    "editing-user-filter": "Modifica del filtro utente",
    "end-date": "Data di fine",
    "expense-bearer": "Numero di lavoro",
    "image-picking": "Picking immagine",
    "meter-state": "Stato contatore",
    "new-travel-warrant": "Nuovo mandato di viaggio",
    "new-travel-warrant-item": "Nuove spese",
    "no-items": "Nessun elemento",
    "no-items-for-search": "Nessun elemento per il filtro",
    "no-saved-user-filters": "Nessun filtri utente salvato",
    "no-time-logs": "Nessun log di tempo",
    "no-travel-warrant-items-for-travel-warrant": "Nessun elemento",
    "no-travel-warrants-for-filter": "Nessuna garanzia di viaggio per il filtro",
    "official-vehicle": "Ufficiale",
    "open-travel-warrant": "Mandato di viaggio aperto",
    "personal-vehicle": "Personale",
    personal: "Personale",
    official: "Ufficiale",
    "personal-vehicles": "Veicoli personali",
    "received-from-contact": "Ricevuto dal contatto",
    "save-header-changes": "Salva le modifiche di intestazione",
    "saving-user-filter": "Salvataggio del filtro utente",
    "sent-to-contact": "Inviato al contatto",
    "show-travel-warrant-items": "Mostra elementi di mandato di viaggio",
    "start-date": "Data di inizio",
    "support-email": "Email di supporto",
    "support-settings": "Impostazioni di supporto",
    "support-tenant-settings": "Impostazioni tenant di supporto",
    "ai-support-settings-tab": "Supporto AI",
    "ai-support-settings-description":
        "Configura chiave API, modelli e limiti per azienda per l'investigatore AI.",
    "ai-support-api-key": "Chiave API",
    "ai-support-api-key-placeholder": "Chiave override opzionale per tenant",
    "ai-support-api-key-description":
        "Lasciala vuota se per questo tenant vuoi continuare a usare la chiave fallback del server.",
    "ai-support-api-key-fallback-note":
        "Puoi salvare qui una chiave API specifica per tenant. Se la lasci vuota, verrà usata la chiave fallback del server.",
    "ai-support-settings-starting-point":
        "Buon punto di partenza: un modello di triage più piccolo/economico, un modello di investigazione più forte, reasoning effort Medium, verbosity Concise, {{maxToolRounds}} round tool, {{maxInputTokensPerTurn}} token input massimi, {{maxOutputTokensPerTurn}} token output massimi e timeout di {{defaultTimeoutMinutes}} minuti.",
    "ai-support-models-loading":
        "Caricamento dei modelli disponibili per questa chiave API...",
    "ai-support-models-loaded":
        "Sono stati caricati {{count}} modelli disponibili. Puoi scegliere dal menu a discesa oppure digitare manualmente l'ID del modello.",
    "ai-support-models-load-failed":
        "Impossibile caricare i modelli per questa chiave API: {{error}}",
    "ai-support-models-load-failed-generic":
        "Impossibile caricare i modelli per questa chiave API.",
    "ai-support-models-empty":
        "Per questa chiave API non è stato restituito alcun modello. Puoi comunque digitare manualmente l'ID del modello.",
    "ai-support-triage-model": "Modello di triage",
    "ai-support-triage-model-placeholder": "Inserisci l'ID del modello di triage",
    "ai-support-triage-model-description":
        "Qui usa un modello più piccolo ed economico, perché il triage non esegue l'intero ciclo di investigazione.",
    "ai-support-investigation-model": "Modello di investigazione",
    "ai-support-investigation-model-placeholder":
        "Inserisci l'ID del modello di investigazione",
    "ai-support-investigation-model-description":
        "Qui usa un modello più forte, perché gestisce tool call e conclusione finale.",
    "ai-support-reasoning-effort": "Livello di reasoning",
    "ai-support-verbosity": "Verbosità del riepilogo del ragionamento",
    "ai-support-max-tool-rounds": "Numero massimo di round tool",
    "ai-support-max-input-tokens": "Token input massimi per turno",
    "ai-support-max-output-tokens": "Token output massimi per turno",
    "ai-support-timeout-minutes": "Timeout (minuti)",
    "ai-support-reasoning-effort-minimal": "Minimo",
    "ai-support-reasoning-effort-low": "Basso",
    "ai-support-reasoning-effort-medium": "Medio",
    "ai-support-reasoning-effort-high": "Alto",
    "ai-support-reasoning-effort-none": "Nessuno",
    "ai-support-verbosity-description": "Controlla il riepilogo del ragionamento, non la lunghezza della risposta finale.",
    "ai-support-input-budget-description": "Budget approssimativo del contesto iniziale. Non limita tutta la cronologia della conversazione.",
    "ai-support-output-budget-description": "Include ragionamento e risposta visibile. Le impostazioni vengono fissate all’avvio della conversazione.",
    "ai-support-output-budget-warning": "Un budget inferiore a 8000 token può interrompere il ragionamento o la risposta. Iniziare con 16000 token.",
    "ai-support-verbosity-auto": "Auto",
    "ai-support-verbosity-concise": "Concisa",
    "ai-support-verbosity-detailed": "Dettagliata",
    "ai-support-settings-warning-over-default":
        "{{field}} è sopra il valore consigliato (consigliato: {{recommended}}, attuale: {{current}}).",
    "ai-support-triage-model-required": "Inserisci un modello di triage.",
    "ai-support-investigation-model-required":
        "Inserisci un modello di investigazione.",
    "ai-support-reasoning-effort-required": "Seleziona il livello di reasoning.",
    "ai-support-verbosity-required": "Seleziona la verbosità.",
    "ai-support-max-tool-rounds-required":
        "Il numero massimo di round tool deve essere maggiore di zero.",
    "ai-support-max-input-tokens-required":
        "I token input massimi devono essere maggiori di zero.",
    "ai-support-max-output-tokens-required":
        "I token output massimi devono essere maggiori di zero.",
    "ai-support-timeout-minutes-required":
        "Il timeout deve essere maggiore di zero.",
    "ticket-signature": "Firma del biglietto",
    "time-logs": "Log di tempo",
    "total-time-tracked": "Tempo totale tracciato",
    "travel-details": "Dettagli di viaggio",
    "travel-start-date-time": "Datetime di inizio di viaggio",
    "travel-type": "Tipo di viaggio",
    "travel-warrant": "Mandato di viaggio",
    "travel-warrant-items": "Spese di mandato di viaggio",
    "travel-warrants-overview": "Panoramica del mandato di viaggio",
    "writing-response-forward": "Risposta di inoltro",
    "writing-response-new": "Scrittura nuova risposta a",
    "writing-response-note": "Scrivere una nota",
    "writing-response-reply": "Scrittura di una risposta a",
    CLOSED: "Chiuso",
    OPEN: "Aperto",
    SENT_TO_PANTHEON: "Inviato a pantheon",
    address: "Indirizzo",
    basic: "Base",
    billable: "Fatturabile",
    by: "Per",
    codebooks: "Codebook",
    codriver: "Co - driver",
    contacts: "Contatti",
    content: "Contenuto",
    costTypeId: "Tipo di costo",
    country: "Paese",
    currency: "Valuta",
    currencyId: "Valuta",
    driver: "Driver",
    edit: "Modifica",
    emails: "Email",
    fullname: "Nome completo",
    general_tenant_settings: "Impostazioni generali",
    header: "Intestazione",
    isPrimary: "Primario",
    makeAndModel: "Marca e modello",
    notes: "Note",
    place: "Luogo",
    registration: "Registrazione",
    report: "Relazione",
    search: "Ricerca",
    transport: "Trasporto",
    travel_warrants: "Mandati di viaggio",
    travel_warrants_settings: "Impostazioni del mandato di viaggio",
    work_records_settings: "Impostazioni dei record di lavoro",
    WorkRecords: "Record di lavoro",
    TravelWarrants: "Mandati di viaggio",
    UserSynchronization: "Sincronizzazione degli utenti",
    BusinessAnalytics: "Analisi",
    DuplicateUserName: "Username già  esiste",
    InvalidUserName:
        "Inserisce un username valido senza diacritici, è possibile utilizzare lettere, numeri e caratteri -. _ @ +",
    "The Password field is required.": "Il campo Password è obbligatorio",
    logout: "Logout",
    language: "Lingua",
    exit: "Uscita",
    return_to_main_user: "Ritorno all'utente principale",
    user_settings: "Impostazioni utente",
    warning: "Avviso",
    cancel: "Annulla",
    activate: "Attiva",
    deactivate: "Disattivare",
    are_you_sure_you_want_to: "Sei sicuro di voler",
    user: "Utente",
    editing_work_hours: "Modifica delle ore di lavoro",
    adding_work_hours: "Aggiunta di ore di lavoro",
    hours: "Ore",
    minutes: "Minuti",
    note: "Nota",
    save: "Salva",
    delete: "Elimina",
    enter_valid_integer: "Inserisce un intero valido",
    editing_work_record: "Modifica record di lavoro",
    adding_work_record: "Aggiunta record di lavoro",
    today: "Oggi",
    cost_bearer: "Numero di lavoro",
    cost_type: "Tipo di costo",
    this_user_id_deactivated: "Questo utente è disattivato",
    users: "Utenti",
    administration: "Amministrazione",
    companies: "Società ",
    activity_reports: "Attività ",
    workers: "Dipendenti",
    settings: "Impostazioni",
    work_records: "Record di lavoro",
    overview: "Panoramica",
    finalizing: "Finalizzazione",
    transfer: "Trasferimento",
    analysis: "Analisi",
    company: "Società ",
    applications: "Applicazioni",
    manual: "Istruzioni",
    end: "Fine",
    next: "Successivo",
    finish_manual: "Finish manuale",
    while_manual_is_open_test_data_is_shown:
        "Mentre le istruzioni sono aperte, vengono visualizzati i dati di prova",
    tutorial_work_records_date_picker:
        "Seleziona l'anno e il periodo per cui vuoi vedere i dati",
    tutorial_work_records_table:
        "I dati per il periodo selezionato vengono visualizzati qui, facendo doppio clic su una riga si apre il modulo di modifica.",
    tutorial_work_records_add_row:
        "Cliccando su 'Aggiungi' si apre la forma di input riga. Una riga rappresenta il periodo e ha un numero di lavoro e di costo.",
    tutorial_work_records_first_day:
        "Cliccando su qualsiasi cella della riga si apre un modulo per l'aggiunta o l'editing del numero di ore lavorate in quel giorno.",
    tutorial_user_top_bar:
        "In questo menu a tendina è possibile effettuare l'accesso o regolare le impostazioni utente di base",
    tutorial_manual_end:
        "Cliccando su 'Istruzioni' è sempre possibile riavviare le istruzioni per la pagina in cui ci si trova attualmente.",
    tutorial_tenant_users:
        'Come amministratore, è possibile visualizzare gli utenti del proprio business cliccando su "Dipendenti"',
    tutorial_work_records_overview:
        "Qui è possibile visualizzare i log di lavoro inseriti per numero di lavoro, tipo di costo e dipendente",
    tutorial_work_records_finalize:
        "Clicca su finalizzare per bloccare e sbloccare il periodo",
    tutorial_work_records_upload:
        'Per trasferire i dati su Pantheon, selezionare "Trasferimento"',
    tutorial_work_records_application:
        'Per aggiungere e modificare i record di lavoro, clicca su "Record di lavoro"',
    tutorial_company_settings:
        "I tipi di costo e la sincronizzazione dei dati (i dipendenti \/ i numeri di lavoro) sono sotto le impostazioni aziendali",
    tutorial_company_settings_cost_types:
        "Qui potete vedere i tipi di costo che voi e i vostri dipendenti potete utilizzare quando si aggiungono i record di lavoro. \n Il nome del tipo di costo verrà  visualizzato mentre si aggiungono i record di lavoro. Vengono visualizzati solo i tipi di costo attivi. Si sceglie il tipo di costo durante la modifica, i tipi di costo vengono trasferiti dal proprio programma Pantheon. Fare doppio clic sulla riga apre il modulo di modifica.",
    tutorial_work_records_tenant_data_sync:
        "Alcuni dati devono essere sincronizzati dal proprio database ai nostri. Questo controllo viene eseguito periodicamente e non deve essere eseguito manualmente. Se si desidera vedere le modifiche prima della successiva sincronizzazione automatica clicca su 'Avvia sincronizzazione'. I dati da sincronizzare sono gli utenti e i tipi di costo.",
    tutorial_work_records_overview_results:
        "La panoramica dei record di lavoro mostra le viste dei dati per titolare, tipo di costo e dipendente. é possibile filtrare la vista per dipendente, tipo di costo, numero di lavoro o periodo.",
    work_records_overview: "Panoramica dei record di lavoro",
    work_records_upload: "Trasferimento record di lavoro",
    tutorial_work_records_finalize_date:
        "Usa questo calendario per selezionare un periodo per finalizzare",
    tutorial_work_records_finalize_users:
        "In questo modo verranno mostrati gli utenti per i quali è disponibile un record di lavoro per il periodo selezionato. é possibile bloccare i dati per l'intero periodo cliccando su 'Blocca tutto'. Cliccando su un impiegato selezionarli per il blocco. Per sbloccare, clicca nuovamente su dipendente o 'Sblocca tutto'.",
    tutorial_work_records_finalize_finalized:
        "Questo mostra i lavoratori i cui dati sono bloccati per il periodo selezionato. Cliccando su un lavoratore cambia lo stato dei dati degli utenti tra bloccati e sbloccati.",
    tutorial_work_records_upload_date:
        "Usa il calendario per selezionare il periodo i cui dati si desidera trasferire al tuo sistema Pantheon.",
    tutorial_work_records_upload_users:
        "Gli utenti che hanno dati per il periodo selezionato vengono mostrati qui.",
    tutorial_work_records_upload_already_uploaded:
        "Se ci sono già  caricamenti, vedrete questo messaggio. I dipendenti che hanno già  dati trasferiti non possono essere selezionati per il ritrasferimento.",
    tutorial_work_records_upload_checked_for_upload:
        "Clicca su un utente per contrassegnarlo per il trasferimento o clicca sul pulsante di trasferimento 'Remaining Workers'. Possono essere selezionati solo gli utenti che hanno presentato i loro dati per la finalizzazione.",
    tutorial_work_records_closed_period:
        "Se il periodo è bloccato questo messaggio verrà  visualizzato. Come amministratore, è possibile clicca su di esso per sbloccare rapidamente il periodo.",
    tutorial_as_admin_user_picker:
        "Come amministratore, qui è possibile selezionare l'utente per il quale si desidera modificare i dati.",
    overview_by_cost_bearer: "Panoramica per numero di lavoro",
    overview_by_cost_type: "Panoramica per tipo di costo",
    overview_by_worker: "Panoramica per dipendente",
    homepage: "Homepage",
    tutorial_work_records_overview_by_cost_bearer:
        "In questo modo verranno mostrati i risultati della tua ricerca, raggruppati per numero di lavoro, tipo di costo e dipendente.",
    tutorial_work_records_overview_results_workers:
        "Nella panoramica per tipo di costo è possibile vedere il tempo totale trascorso per tipo di costo.",
    tutorial_work_records_overview_workers:
        "é possibile visualizzare una visione dettagliata dei record per ciascun dipendente nel periodo per la panoramica dei dipendenti.",
    tutorial_work_records_overview_workers_edit:
        "Cliccando sull'icona accanto al lavoratore si apre una vista di applicazione del record di lavoro in cui è possibile modificare i dati visualizzati.",
    tutorial_work_records_overview_locked:
        "Ecco come vengono visualizzati i periodi bloccati",
    tutorial_work_records_dashboard:
        'Per aggiungere e modificare i record di lavoro, clicca su "Record di lavoro"',
    tutorial_work_records_closed_period_user:
        "Se il periodo è bloccato questo messaggio verrà  visualizzato",
    manual_end: "Fine delle Istruzioni",
    work_record_period_closed_and_cannot_be_changed:
        "Questo periodo è bloccato e non puà² essere modificato",
    work_record_ready_to_finalize_and_cannot_be_changed:
        "Questo periodo è stato contrassegnato come pronto a finalizzare, per modificare l'utilizzo dei dati 'Non pronto a finalizzare'",
    do_you_want_to_unlock_work_record_period: "Vuoi sbloccare il periodo?",
    yes: "Sà¬",
    no: "No",
    finalizing_period: "Periodo di finalizzazione",
    tutorial_work_records_send_to_finalize:
        "Cliccando qui per la finalizzazione, il periodo viene temporaneamente bloccato e inviato all'amministratore in fase di revisione prima della chiusura finale del periodo. Solo i periodi inviati per finalizzare possono essere finalizzati.",
    personal_data: "Dati personali",
    download: "Scarica",
    contact_us_for_deleting_user_data: "Contattaci per eliminare il tuo account.",
    personal_data_download_text:
        "Il tuo account contiene le informazioni personali che ci hai fornito. é possibile scaricare o eliminare queste informazioni in questa pagina.",
    personal_data_delete_text:
        "L'eliminazione di queste informazioni elimina anche in modo permanente il tuo account. Se si prende questa azione, il proprio account e i dati non possono pià¹ essere recuperati.",
    login_again_with_new_user_details:
        "Registrati con le nuove informazioni dell'utente",
    profile: "Profilo",
    username: "Username",
    email: "E-mail",
    save_changes: "Salva le modifiche",
    you: "Tu",
    total: "Totale",
    client: "Client",
    name: "Nome",
    not_ready_to_finalize: "Non pronto a finalizzare",
    send_to_finalize: "Invia per finalizzare",
    login_or_using_app_in_period:
        "Primo accesso o utilizzo dell'applicazione in un periodo",
    send_again: "Reinvio",
    delete_report: "Relazione di cancellazione",
    are_you_sure_you_want_to_delete_report:
        "Sicuri di voler eliminare il report e tutti gli articoli di report?",
    report_details: "Dettagli del report",
    active_users: "Utenti attivi",
    is_sent: "Inviato",
    last_month: "Ultimo mese",
    next_month: "Il mese prossimo",
    packets: "Pacchetti",
    actions: "Azioni",
    editing_settings: "Modifica impostazioni",
    companiesLowerCase: "società ",
    application_packets: "Pacchetti di applicazioni",
    adding_packet: "Aggiunta di un pacchetto",
    sql_form: "Modulo SQL",
    sql_response: "Risposta SQL",
    fix_and_run_query: "Correggere ed eseguire la query",
    start_query: "Eseguire la query",
    add: "Aggiungi",
    add_packet: "Aggiungi pacchetto",
    company_does_not_have_any_packets:
        "L'azienda non ha pacchetti applicativi attivi",
    without_company: "Nessuna azienda",
    without_user: "Nessun utente",
    mimic: "Impersonare",
    editing_user: "Modifica utente",
    this_user_can_administer_everything:
        "Questo utente puà² amministrare ai nostri utenti",
    firstname: "Nome primo",
    lastname: "Cognome",
    user_roles: "Ruoli utente",
    pick: "Scegli",
    for_pantheon_settings_pick_company:
        "Seleziona una società  per vedere le impostazioni Pantheon",
    pantheon_user: "Utente di Pantheon",
    pick_a_user: "Selezionare un utente",
    document_types: "Tipi di documenti",
    default_document_type_is_required:
        "Il tipo di documento predefinito è obbligatorio",
    default_document_type: "Il tipo di documento predefinito",
    take_from_user: "Prendi dall'utente",
    CanChooseDocumentType: "Selezione di un tipo di documento",
    MakePDFOnFinalizingOrder: "Crea un PDF dal tuo ordine",
    WarnIfOrderItemQuantityMoreThanAvailable:
        "Avverte se la quantità  di item è maggiore di quella disponibile",
    PrintOnFinalizingOrder: "Effettuare una stampa dell'ordine",
    ShowOnlyAvailableItemsInStockItemsView:
        "Mostra solo gli elementi disponibili nella panoramica del magazzino",
    StockInitiallyShowAllAvailableOnStock:
        "Visualizza inizialmente tutti gli articoli in stock nella panoramica del magazzino",
    InitiallyShowAllAvailableOnStock:
        "Visualizza inizialmente tutti gli articoli in memoria in cerca",
    SquareTilesForArticlePicker: "Piastrelle quando si seleziona un articolo",
    RestrictSearchToSmallerSet: "Limita la ricerca a 10 elementi",
    UseCachingForArticleSearch: "Utilizza cache",
    UseCachingForCustomerSearch: "Utilizza cache",
    RepeatLastArticleSearch: "Ripeti ricerca articolo precedente",
    DetailedItemViewInDocument:
        "Vista dettagliata dell'elenco degli articoli aggiunti",
    UseCachingForWorkOrders: "Utilizza cache",
    CacheDuration: "Durata (minuti)",
    BluetoothPrintCopiesNumber: "Numero di copie da stampare",
    UseDarkTheme: "Utilizza un tema oscuro",
    OrderShouldMakeAReservation:
        "Effettuare una prenotazione in stock dal tuo ordine",
    CanEditOrderItemPrice: "Variazione dei prezzi",
    DisalowOrderItemQuantityMoreThanAvailable:
        "La quantità  di un articolo non deve essere maggiore di quella disponibile",
    UseSerialForItems: "Utilizza il numero di serie per gli articoli",
    CanDeleteOrderItems: "Puà² cancellare gli articoli dell'ordine",
    CanDeleteMoveItems: "Puà² cancellare gli articoli dell'ordine di spedizione",
    warehouse: "Magazzino",
    article_search: "Articolo Ricerca",
    customer_search: "Destinatario della ricerca",
    viewing_selected_articles: "Visualizza articoli selezionati",
    work_orders: "Ordini di lavoro",
    cache: "Cache",
    print: "Stampa",
    rest: "Altro",
    internal: "Interno",
    documents: "Documenti",
    confirm_download: "Conferma download",
    onix_phone_settings: "Impostazioni di onix Phone",
    last_reported_version: "Ultima versione riportata",
    ares_version_source_cached: "Valore in cache",
    ares_version_source_unavailable: "Controllo non disponibile",
    ares_update_queued: "L'aggiornamento Ares e stato avviato in background.",
    ares_update_queued_all_databases:
        "L'aggiornamento Ares e stato avviato in background per questo e i database collegati.",
    ares_update_in_progress: "Aggiornamento Ares in corso.",
    ares_update_in_progress_all_databases:
        "Aggiornamento Ares in corso per questo e i database collegati.",
    ares_update_finished: "Aggiornamento Ares completato.",
    ares_update_finished_all_databases:
        "Aggiornamento Ares completato per questo e i database collegati.",
    ares_update_failed: "Aggiornamento Ares completato con errore.",
    ares_update_failed_all_databases:
        "Aggiornamento Ares completato con errore su questo o un database collegato.",
    ares_update_state_queued: "In coda",
    ares_update_state_running: "In corso",
    ares_update_state_finished: "Completato",
    ares_update_state_failed: "Errore",
    last_token_refresh: "Ultimo aggiornamento token",
    last_login: "Ultimo accesso",
    onix_phone_details: "Dettagli Onix Phone",
    none: "Nessuno",
    pantheon_not_connected_cannot_change:
        "Pantheon non connesso, modifica disabilitata",
    pantheon_successfully_connected: "Pantheon connesso correttamente",
    adding_user: "Aggiunta di un utente",
    loading: "Caricamento",
    password: "Password",
    add_a_user: "Aggiungi utente",
    company_not_selected: "Società  non selezionata",
    onix_phone: "Telefono onix",
    version: "Versione",
    platform: "Piattaforma",
    active: "Attivo",
    new_user: "Nuovo utente",
    change_user: "Modifica utente",
    user_search: "Ricerca utente",
    show_deactivated: "Mostra disattivato",
    loading_initial_user_settings:
        "Caricamento delle impostazioni dell'utente iniziale",
    you_have_no_applications: "Non hai accesso alle applicazioni",
    "The Email field is required.": "Il campo e-mail è obbligatorio.",
    "The Email field is not a valid e-mail address.":
        "Il campo deve essere un indirizzo e-mail valido.",
    "The Title field is required.": "Il titolo del campo è obbligatorio.",
    "The Message field is required.": "Il messaggio di campo è obbligatorio.",
    username_or_email: "Username o e-mail",
    login: "Login",
    key: "Chiave",
    value: "Valore",
    mimicking_user: "Impersonare l'utente",
    mimicking_in_progress: "Impersonare l'utente in corso",
    page_not_found: "Pagina non trovata",
    link: "Il link",
    is_written_wrong_or_does_not_exist_anymore:
        "è scritto male o non esiste pià¹",
    back: "Indietro",
    back_to_dashboard: "Torna all'homepage",
    not_possible_to_delete_cost_type:
        "Non è possibile cancellare il tipo di costo '{0}', esistono record di lavoro che lo utilizzano. Questo tipo di costo puà² essere disattivato in modo che non venga utilizzato in futuro.",
    company_settings: "Impostazioni della società ",
    cost_types: "Tipi di costo",
    cost_type_options: "Tipo di guadagno",
    you_have_no_cost_types: "Non hai tipi di costo",
    add_cost_type: "Aggiungi tipo di costo",
    editing_cost_type: "Modifica tipo di costo",
    adding_cost_type: "Aggiunta di nuovo tipo di costo",
    code: "Codice",
    active_cost_types_tooltip:
        "I tipi di costo attivi possono essere utilizzati quando si aggiungono record di lavoro",
    data_sync: "Sincronizzazione dei dati",
    sync_in_progress: "Sincronizzazione in corso ...",
    last_check: "Ultimo controllo",
    last_sync: "Ultima sincronizzazione",
    start_sync: "Avviare la sincronizzazione",
    user_not_active: "Utente non attivo",
    save_password: "Salva password",
    administrator: "Amministratore",
    name_and_surname: "Nome e cognome",
    company_users: "Utenti della società ",
    current_password: "Password corrente",
    new_password: "Nuova password",
    repeat_password: "Ripeti nuova password",
    change_password: "Salva password",
    password_changed_successfully: "Password modificata correttamente.",
    total_hours: "Ore totali",
    change_worker_cost_type_or_period:
        "Prova a cambiare dipendente, tipo di costo o periodo",
    forceShowAvailableOnStock: "U pregledu prikaži dostupno",
    Inventory: "Inventura",
    WarehouseReceipt: "Primka",
    date: "Data",
    time: "Tempo",
    description: "Descrizione",
    no_user: "Senza utente",
    from: "Da",
    to: "A",
    all_dropdown: " - Tutto - ",
    month_picker: "Picker del mese",
    reset_to_default: "Reimpostazione al default",
    by_cost_bearer: "Per numero di lavoro",
    by_cost_type: "Per tipo di costo",
    by_worker: "Per dipendente",
    worker: "Dipendente",
    close: "Chiudi",
    all_workers: "Tutti i dipendenti",
    rest_of_workers: "Restanti dipendenti",
    only_picked_workers: "Solo dipendenti selezionati",
    for_this_period_data_exists_in_pantheon:
        "Ci sono già  dati a Pantheon per questo periodo. Solo i dati dei restanti dipendenti possono essere trasferiti.",
    start_data_upload: "Avvio trasferimento dati",
    period: "Periodo",
    period_is_locked: "Il periodo è finalizzato",
    unlock_all: "Sblocca tutti",
    lock_all: "Bloccare tutto",
    no_items_for_selected_period: "Nessun elemento per il periodo selezionato",
    save_note: "Salva nota",
    year: "Anno",
    month: "Mese",
    on_date: "In data",
    "User not ready":
        "Questo utente non è pronto a lavorare, contattaci per un aiuto.",
    "User not found": "Utente non trovato.",
    "The UserNameOrEmail field is required.":
        "é richiesto username o campo E-mail.",
    "Invalid password": "Password errata.",
    no_results: "Nessun risultato",
    pick_month: "Scegli un mese",
    no_items: "Nessun elemento",
    or: "Oppure",
    never: "Mai",
    pick_date: "Scegli una data",
    calendar: "Calendario",
    no_workers_for_selected_period:
        "Nessun utente con dati per il periodo selezionato",
    not_sent_to_finalize: "Non inviato per finalizzare",
    "Polje trenutna lozinka je obavezno.":
        "La password corrente del campo è obbligatoria.",
    "Polje nova lozinka je obavezno.": "é necessaria la nuova password di campo.",
    "Nova lozinka i ponovljena lozinka se ne podudaraju.":
        "La nuova password e la password ripetuta non sono le stesse.",
    "Nova lozinka mora imati barem 6 i najviše 100 znakova.":
        "La nuova password deve avere almeno 6 e al massimo 100 caratteri.",
    "Trenutna lozinka neispravna.": "Password corrente errata.",
    work_records_transfer_successful: "Trasferimento completato correttamente",
    there_was_an_error: "Si è verificato un errore",
    add_multiple_work_hours: "Aggiungi ore di lavoro selezionate",
    are_you_sure_you_want_to_delete_work_record:
        "Sicuri di voler eliminare la riga e tutte le ore di lavoro correlate con esso?",
    details: "Dettagli",
    untoggle_multiple_work_hours: "Unselezionare le ore di lavoro",
    selected_days_for_work_hours: "Date selezionate",
    adding_multiple_work_hours: "Aggiunta di pià¹ ore di lavoro",
    number_of_multiple_work_hours: "Ore di lavoro selezionate",
    exceeding_work_hours_for:
        "Giorni per i quali le ore di lavoro supererebbero le 24 ore",
    support: "Supporto",
    "data-already-uploaded": "Dati già  trasferiti",
    "data-not-ready-to-finalize":
        "Dati non contrassegnati come pronti a finalizzare",
    "data-not-finalized": "Dati non finalizzati",
    contact: "Contatto",
    priority: "Priorità ",
    source: "Fonte",
    status: "Stato",
    type: "Tipo",
    due_date: "Data di scadenza",
    Closed: "Chiuso",
    High: "Alto",
    Low: "Basso",
    Medium: "Medio",
    Open: "Aperto",
    Pending: "In sospeso",
    Phone: "Telefono",
    Resolved: "Risolto",
    Urgent: "Urgente",
    WaitingOnCustomer: "In attesa sul cliente",
    WaitingOnThirdParty: "In attesa di terze parti",
    "add-note": "Aggiungi nota",
    "add-ticket": "Aggiungi ticket",
    agent: "Proprietario",
    "assigned-to": "Assegnato a",
    dueToday: "Dovuto oggi",
    forward: "Avanti",
    mine: "Mine",
    "new-ticket": "Nuovo biglietto",
    onHold: "In attesa",
    open: "Aperto",
    overdue: "Sovrastato",
    reply: "Rispondi",
    "reported-by": "Segnalato da",
    "ticket-details": "Dettagli del biglietto",
    "ticket-is-due": "Questo biglietto è sovrastato",
    title: "Titolo",
    unresolved: "Irrisolto",
    "save-filter": "Salva filtro",
    filter: "Filtro",
    this_user_is_deactivated: "Questo utente non è attivo",
    cost_group_options: "Gruppo di costo",
    "The PantheonCostGroup field is required.": "Scegli un gruppo di costo",
    "The CostType field is required.": "Inserire nome tipo di costo",
    "The PantheonCostType field is required.": "Scegli un tipo di guadagno",
    "enter-a-valid-time": "Inserisce un tempo valido",
    allowance: "Indennità ",
    "total-per-diems": "Giorni per diem",
    "has-backing-invoice": "R1 fattura",
    hasBackingInvoice: "R1 fattura",
    "send-to-pantheon": "Invia a Pantheon",
    "travel-warrant-closed": "Il mandato di viaggio è chiuso",
    "travel-warrant-sent-to-pantheon":
        "Il mandato di viaggio è inviato a Pantheon",
    travels: "Viaggi",
    "travel-type-short": "Viaggi",
    meter: "Contatore",
    departure: "Partenza",
    return: "Ritorno",
    expenses: "Spese",
    notForPayment: "Non a pagamento",
    "total-km": "Totale KM",
    "adding-new-contact": "Aggiunta di nuovo contatto",
    "editing-contact": "Modifica del contatto",
    "paging-of": "di",
    "paging-on-page": "a pagina",
    "paging-showing": "Visualizzazione",
    page: "Pagina",
    fullName: "Nome completo",
    webshop: "Negozio web",
    "webshop-items": "Shop web - articoli",
    "adding-web-shop-item": "Aggiunta articolo",
    "editing-web-shop-item": "Modifica articola",
    featured: "Caratterizzato",
    discounted: "Scontati",
    "featured-categories": "Caratterizzato",
    "adding-featured-category": "Aggiunta di categoria comparata",
    "editing-featured-category": "Modifica della categoria figurata",
    "To Pantheon": "A Pantheon",
    "From Pantheon": "Da Pantheon",
    "confirm-changing-travel-warrant-status-to-closed":
        "Una volta chiuso il mandato di viaggio non puà essere aperto. Cercheremo di inviare il mandato di viaggio chiuso a Pantheon immediatamente o quando si verifica la successiva sincronizzazione dei dati. Vuoi procedere?",
    "this-page-has-multiple-tutorials":
        "In questa pagina sono presenti pià esercitazioni",
    "pick-tutorial-to-get-started": "Scegli un tutorial per iniziare",
    travel_warrants_from_dashboard:
        "Cliccando su 'Travel warrant' è possibile iniziare ad aggiungere mandati di viaggio",
    travel_warrants_tutorial_company_settings:
        "Cliccando su 'Impostazioni' è possibile modificare le impostazioni della propria azienda e avviare la sincronizzazione da e verso il proprio database Pantheon.",
    travel_warrants_status_dropdown:
        "Cliccando su 'Stato' dropdown è possibile modificare il filtro di stato del mandato di viaggio. I mandati di viaggio con stato 'Aperto' possono essere modificati, quelli con status 'Chiusi' sono in fase di preparazione all'invio a Pantheon e quelli con status 'Inviato al Pantheon' sono già  trasferiti al tuo sistema Pantheon.",
    tutorial_travel_warrant_worker:
        "In qualità  di amministratore, è possibile visualizzare i mandati di viaggio di tutti i lavoratori della propria azienda",
    travel_warrants_search_component:
        "Qui è possibile inserire un termine per cercare mandati di viaggio",
    travel_warrants_table_status_explanation:
        "Se lo stato è 'Chiuso 'e non rosso, il mandato di viaggio è ancora pronto per l'invio, se è 'Chiuso' e rosso c'è stato un errore quando il sistema ha cercato di sincronizzare il mandato di viaggio. Cliccando su quel mandato di viaggio è possibile visualizzare maggiori dettagli.",
    travel_warrants_add_travel_warrant:
        "Cliccando su 'Aggiungi' è possibile iniziare ad aggiungere un nuovo mandato di viaggio",
    new_travel_warrant_tab:
        "Il contenuto della scheda 'Travel' mostra i dati di intestazione del mandato di viaggio.",
    tutorial_travel_warrant_pick_worker:
        "In qualità  di amministratore è possibile scegliere un lavoratore per il quale si sta effettuando il mandato di viaggio",
    new_travel_warrant_pick_project:
        "Qui puoi scegliere il progetto di mandato di viaggio. Se il soggetto del progetto ha il posto e il paese quei campi saranno precompilati per voi.",
    "new-travel-warrant-general-transport":
        "Qui è possibile inserire il tipo di trasporto se non si tratta di un'azienda o di un veicolo personale",
    "new-travel-warrant-official-vehicle":
        "Qui puoi scegliere un veicolo aziendale che abbiamo sincronizzato dal tuo sistema Pantheon",
    "new-travel-warrant-personal-vehicle":
        "Se stai usando un veicolo personale puoi sceglierlo qui",
    "new-travel-warrant-arrival-date":
        "Impostare la data e l'ora di partenza e di arrivo cosà¬ possiamo calcolare le tue per diere",
    "new-travel-warrant-personal-vehicle-callout":
        "Per aggiungere un nuovo veicolo personale clicca qui, segui il link 'Modifica altri veicoli personali' nel modulo che si apre se si desidera modificare i veicoli esistenti",
    "new-travel-warrant-items-tab":
        "Quando si salvano i dettagli di intestazione, la scheda delle spese di viaggio di viaggio mostrerà ",
    "new-travel-warrant-items-table":
        "Qui puoi vedere le spese di viaggio aggiunte al mandato di viaggio. ",
    "manual-is-active":
        "Tutorial è attivo, se c'è un problema, clicca qui per disabilitare il tutorial.",
    "travel-warrant-header-has-unsaved-changes":
        "Questa intestazione di garanzia di viaggio ha modifiche non salvate, sei sicuro di voler lasciare questa pagina?",
    "Personal vehicle does not belong to this user":
        "Il veicolo non appartiene all'utente",
    "Travel warrant country not set":
        "Per il trasferimento è necessario selezionare il paese sul mandato di viaggio",
    "adding-new-company": "Aggiunta nuova società ",
    "editing-company": "Società  di modifica",
    companyId: "Società ",
    contactId: "Contatto",
    "adding-new-email": "Aggiunta di email",
    "editing-email": "Modifica email - a",
    "The ContactCompanyId field is required.":
        "La società  di contatti è obbligatoria",
    "no-tickets": "Nessun ticket per il filtro corrente",
    "is-primary": "Primario",
    "The ContactEmailId field is required.": "Scegli un Email",
    "The ContactId field is required.": "Scegli un contatto",
    "unread-messages": "Messaggi non letti",
    BluetoothPrinterCharacterWidth: "Larghezza della pagina",
    travelEndDateTime: "Fine del viaggio",
    "travel-end-date-time": "Fine del viaggio",
    conversion: "Tasso di conversione",
    "The Conversion field is required.": "é richiesto il tasso di conversione",
    "delete-travel-warrant": "cancellare mandato di viaggio?",
    "expenses-total": "Spese totali",
    "down-payment": "Anticipo",
    "daily-allowance": "Per diem",
    quantity: "Quantità ",
    "travel-warrant-is-sent-to-finalize":
        "Questo mandato di viaggio è stato segnato come pronto a finalizzare, per cambiare l'uso dei dati 'Non pronto a finalizzare' bottone",
    "Travel warrant is sent to finalize":
        "Questo mandato di viaggio è stato segnato come pronto a finalizzare",
    SENT_TO_FINALIZE: "Inviato per finalizzare",
    "travel-warrant-is-closed": "Questo mandato di viaggio è chiuso",
    amount: "Importo",
    "cost-description": "Descrizione del costo",
    attachment: "Allegato",
    "picking-attachment": "Scegli un allegato",
    "departure-place": "Luogo di partenza",
    "enter-valid-date-range": "Inserisce un intervallo di date valido",
    send: "Invia",
    "add-attachment": "Aggiungi allegato",
    "Pick a currency": "Scegli una valuta",
    "Enter a conversion rate": "Inserire un tasso di conversione",
    "notify-email-or-agent": "Agente di notifica",
    "save-as-new-filter":
        "Salvare le impostazioni di filtro attive correnti come nuovo filtro",
    modifiedOn: "Modificato",
    createdOn: "Creato",
    dateDue: "Data di scadenza",
    "no-title": " - Nessun titolo - ",
    "connect-to-contact": "Riassegna indirizzi e-mail",
    "support-email-password": "Password e-mail di supporto",
    "sql-error-547":
        "Ci sono dati relativi a questa riga e non possono essere cancellati",
    "unknown-sql-error": "Errore del server SQL sconosciuto",
    "contact-and-company": "Contatto e società ",
    "status-and-agent": "Stato e agente",
    Today: "Oggi",
    Yesterday: "Ieri",
    ThisWeek: "Questa settimana",
    ThisMonth: "Questo mese",
    LastMonth: "Ultimo mese",
    CustomRange: "Intervallo di date",
    "support-redirect-all-to-sender":
        "Reindirizzare tutte le email in uscita al mittente",
    import: "Importa",
    "saved-files-settings": "Impostazioni di salvataggio dei file",
    "temporary-agent": "Agente",
    agents: "Proprietario e agente",
    support_dashboard: "Panoramica",
    "status-and-priority": "Stato e priorità ",
    "notify-of-unread-messages": "Invia notifiche e-mail per nuovi messaggi",
    "do-you-want-to-delete": "Sei sicuro di voler eliminare {oggetto}?",
    "genitiv-message": "messaggio",
    "writing-response-edit-note": "Modifica di una nota",
    "save-note": "Salva le modifiche",
    "other-settings": "Altro",
    upload: "Upload",
    croatian: "Croato",
    english: "Inglese",
    dashboard: "Home",
    "codebooks-companies": "Società ",
    "codebooks-contacts": "Contatti",
    "support-dashboard": "Dashboard di supporto",
    "edit-ticket": "Biglietto",
    "activity-reports": "Rapporti di attività ",
    "activity-records": "Record di report attività ",
    "work-records-overview": "Panoramica dei record di lavoro",
    "work-records": "Record di lavoro",
    finalize: "Finalizzazione",
    "travel-warrants": "Mandati di viaggio",
    italian: "Italiano",
    other: "Altro",
    "open-tasks": "Compiti",
    "remove-ticket": "Rimuovi il biglietto",
    "are-you-sure-you-want-to-delete-this-ticket":
        "Sei sicuro di voler rimuovere questo biglietto? Verranno eliminati tutti i registri, i messaggi e i file / immagini salvati.",
    "not-assigned-ticket": "Biglietto non assegnato",
    "your-ticket": "Il tuo biglietto",
    "ticket-delegated-to-you": "Biglietto delegato a te",
    "ticket-you-delegated": "Biglietto che hai delegato",
    for: "Per",
    "The AgentId field is required.": "Scegli un agente",
    "Enter a positive timespan": "Immettere l'ora",
    "no-title-warning": " - No titolo - ",
    project: "Il progetto",
    "adding-new-project": "Aggungi il progetto",
    "codebooks-projects": "I progetti",
    "editing-project": "Modificare un progetto",
    "no-projects-found": "Nessun progetto trovato o nessun progetto attivo",
    finished: "Completato",
    "no-agents-found": "Nessun agenti trovato",
    "are-you-sure-you-want-to-close-without-billable-time-log":
        "Questo biglietto non ha record di tempo addebitabili. Sei sicuro di voler continuare?",
    "merge-ticket": "Collegare il biglietto",
    "merge-ticket-from": "Scarica tutto dal ticket",
    "ticket-cannot-merge-into-itself": "Un ticket non può essere unito a sé stesso",
    "delete-company": "Elimina azienda",
    "deleting-company": "Eliminazione azienda...",
    "delete-company-confirmation":
        "Eliminare l'azienda {{name}}? L'eliminazione fallira se esistono record collegati.",
    "merge-company": "Unisci azienda",
    "merge-company-description": "Sposta tutto da un'altra azienda su questa.",
    "merge-company-search": "Cerca azienda da unire",
    "merge-company-suggestions": "Aziende simili",
    "merge-company-confirm": "Unisci in questa azienda",
    "merge-company-conflicts-found":
        "Sono stati trovati conflitti. Controlla ogni campo prima di completare l'unione.",
    "merge-company-preview-description":
        "Scegli come risolvere ogni campo prima di unire l'azienda sorgente nell'azienda di destinazione.",
    "merge-company-fields": "Campi",
    "merge-company-related-items": "Record collegati",
    "merge-company-source": "Origine",
    "merge-company-target": "Destinazione",
    "merge-company-action": "Azione",
    "merge-company-conflict": "Conflitto",
    "merge-company-empty-value": "Vuoto",
    "merge-company-resolve-and-merge": "Risolvi e unisci",
    "merge-company-action-keep-target": "Mantieni destinazione",
    "merge-company-action-take-source": "Prendi origine",
    "merge-company-action-merge-both": "Unisci entrambi",
    "merge-company-outcome-will-move": "Verrà spostato",
    "merge-company-outcome-merge-existing": "Si unirà ai record esistenti",
    "merge-company-outcome-no-change": "Nessuna modifica",
    "merge-company-source-count": "Origine: {{count}}",
    "merge-company-target-count": "Destinazione: {{count}}",
    "merge-contact": "Unisci contatto",
    "merge-contact-description": "Sposta tutto da un altro contatto su questo.",
    "merge-contact-search": "Cerca contatto da unire",
    "merge-contact-confirm": "Unisci in questo contatto",
    choose: "Scegli",
    clear: "Rimuovi",
    program: "Programma",
    tickets: "I biglietti",
    "support-woocommerce-settings": "WooCommerce impostazioni",
    secret: "Segreta",
    location: "Sito",
    AGENTS: "AGENTI",
    "ccemail-not-finished-do-you-want-to-continue":
        "Hai un messaggio di posta elettronica CC incompleto, vuoi continuare?",
    "attachment-mentioned-but-does-not-exist":
        "Il contenuto del messaggio menziona un allegato, ma non è stato aggiunto alcun allegato. Vuoi continuare senza di essi?",
    todo: "Promemoria",
    "no-todos": "Nessuna promemoria",
    "add-todo-button": "Aggungi il promemoria",
    "mention-agents": "agenti",
    culture: "Stato",
    timezone: "Fuso orario",
    "there-are-some-updates-a-refresh-is-required":
        "Postoje promjene za koje je potrebno osvježiti stranicu",
    refresh: "Ricaricare",
    "time-format": "Formato data e ora",
    support_todos: "Promemoria",
    "support-todos": "Promemoria",
    "adding-support-todo": "Aggiungendo una premoria",
    "editing-support-todo": "Modificare una premoria",
    "ticket-title": "Titolo di biglietto",
    dateTime: "Data",
    ticketId: "Biglietto",
    synced: "Sincronizzato",
    "synchronize-timelogs": "Sincronizzare gli log di tempo",
    "document-number": "Numero del documento",
    "total-costs": "Totali",

    "Travel warrant expense bearer not set": "Set expense bearer",
    "Travel warrant place not set": "Place not set",
    "Travel warrant start date and time not set": "Set start date and time",
    "Travel warrant end date and time not set": "Set end date and time",
    "created-time-log-on-date": "Time log date",
    "time-log-sync": "Time logs synchronization",
    "time-log-exported": "Esportato",
    "time-log-exported-on": "Esportato {{date}}",
    "time-log-not-exported": "Non esportato",
    "last-month": "Last month",
    "current-month": "Current month",
    nextWeek: "Next week",
    lastWeek: "Last week",
    lastDay: "Yesterday",
    nextDay: "Tomorrow",
    last: "Last",
    "responsible-agent": "Responsible agent",
    "reset-all": "Reset all",
    "are-you-sure": "Are you sure?",
    "reset-ticket-data": "reset ticket data?",
    "want-to-delete-message": "delete message?",
    "want-to-regenerate-message": "regenerate message with new signature?",
    "want-to-close-without-billable-time-log":
        "close ticket without any billable time?",
    "want-to-continue-without-attachment": "continue without an attachment?",
    "send-later": "Più tardi",
    "send-later-title": "Fuori orario di lavoro: invia all'inizio del prossimo orario di lavoro ({{time}})",
    "scheduled-send": "invio programmato: {{time}} (il cliente non lo vede ancora)",
    "send-now": "Invia ora",
    "send-scheduled-now-confirm": "inviare il messaggio ora?",
    "want-to-merge-contact-with-contact":
        "merge: {emails} to contact {contact}. All tickets and companies will be merged to the new contact.",
    "want-to-continue-to-delete-without-where-query":
        "continue with DELETE method even without WHERE condition?",
    want_to_delete_report: "delete report and all it's items?",
    support_tasks: "Tasks",
    "support-tasks": "Tasks",
    "task-title": "Task message",
    customers: "Customers",
    databases: "Databases",
    support_time_logs: "Time logs",
    "canned-responses": "Risposte rapide",
    "canned-response-add": "Aggiungi risposta rapida",
    "canned-response-edit": "Modifica risposta rapida",
    "canned-response-title": "Titolo",
    "canned-response-content": "Contenuto",
    "insert-canned-response": "Inserisci risposta rapida",
    "manage-canned-responses": "Gestisci risposte rapide",
    onixPhoneCompaniesOverview: "Aziende OnixPhone",
    supportCompany: "Azienda di supporto",
    activeUsers: "Utenti attivi",
    showOnlyWithoutSupportCompany: "Solo senza azienda di supporto collegata",
    noSupportCompany: "Nessuna azienda di supporto collegata",
    companiesCount: "Aziende: {{count}}",
    activeUsersCount: "Utenti attivi: {{count}}",
    selectOnixPhoneCompany: "Collega all'azienda OnixPhone",
    linkOnixPhoneCompany: "Collega",
    onixPhoneExternalId: "ExternalId per OnixPhone",
    currentLinkedOnixPhoneCompany: "Azienda OnixPhone collegata",
    previous: "Previous",
    "next-one": "Next",
    "marservis-work-orders": "Work orders",
    "The ItemId field is required.": "Odaberite artikl",
    "The UserId field is required.": "Odaberite radnika",
    "codebooks-customers": "Customers",
    "adding-customer": "Adding a customer",
    "editing-customer": "Editing a customer",
    subject: "Subject",
    subjectId: "Subject",
    "work-order-items": "Work order items",
    "adding-work-order": "Adding a work order",
    "editing-work-order": "Editing a work order",
    projectId: "Project",
    "adding-work-order-item": "Adding a work order item",
    "editing-work-order-item": "Editing a work order item",
    "adding-work-order-item-work": "Adding work order item work",
    "editing-work-order-item-work": "Editing work order item work",
    "work-order-item-work": "Work order item work",
    cause: "Cause",
    remedy: "Remedy",
    connectionSettings: "Connection settings",
    myEInvoiceSettings: "My e-invoce",
    "Travel warrant sent to pantheon":
        "Travel warrant is already sent to Pantheon",
    projects: "Projects",
    countryId: "Country",
    contactName: "Contact name",
    mail: "E-mail",
    longName: "Long name",
    phone: "Phone",
    vatidPrefix: "VAT ID prefix",
    vatid: "VAT ID",
    shortName: "Name",
    "done-hours": "Work hours",
    workOrderWorkerPickerIncludesInactiveWorkers:
        "Mostra lavoratori inattivi nella selezione lavoratori degli ordini di lavoro",
    showInventoryNumberOnWorkOrders: "Mostra numero inventario su ordini di lavoro",
    "company-notes": "Note aziendali",
    "comma-separated-tags": "Tag separati da virgola",
    "this-is-not-our-customer": "Non è un nostro cliente",
    "OldTickets": "Ticket molto vecchi",
    "HighPriorityTickets": "Ticket a priorità alta",
    "high-priority": "ALTA",
    "old-tickets-short": "VECCHIO",
    "last-activity": "Ultima attività",
    "onixPhone": "OnixPhone",
    "onixPhoneCompany": "Azienda OnixPhone",
    "externalId": "ID esterno",
    "userCount": "Numero utenti",
    "usernames": "Utenti",
    activityCheckSql: "SQL di verifica attività",
    "new-messages-available": "Nuovi messaggi disponibili",
    "viewing-now": "Stanno guardando ora",
    "ares-activity": "Attività Ares",
    "ares-activity-last-check": "Ultimo controllo attività",
    "ares-activity-result": "Esito controllo attività",
    aresActivityReport: "Report attività Ares",
    aresDeploymentGroup: "Gruppo Ares",
    "Select Ares implementation.": "Seleziona un'implementazione Ares.",
    "Select database.": "Seleziona un database.",
    "Select Ares group.": "Seleziona un gruppo Ares.",
    "Ares group installed for {{companyName}}.":
        "Gruppo Ares installato per {{companyName}}.",
    "Create companies": "Crea aziende",
    "Create companies ({{count}})": "Crea aziende ({{count}})",
    "Companies were created!": "Aziende create!",
    "Install selected Ares group": "Installa il gruppo Ares selezionato",
    "Install selected Ares group for new company":
        "Installa il gruppo Ares selezionato per nuova azienda",
    "New Ares group for new company": "Nuovo gruppo Ares per nuova azienda",
    "Install Ares group": "Installa gruppo Ares",
    "Installing Ares group...": "Installazione gruppo Ares...",
    "Ares implementations": "Implementazioni Ares",
    "Ares versions": "Versioni Ares",
    "Loading versions...": "Caricamento versioni...",
    "Installation steps": "Passaggi di installazione",
    "On all databases": "Su tutti i database",
    "Update all Areses": "Aggiorna tutti gli Ares",
    "Search by database or company": "Cerca per database o azienda",
    "Search Ares group": "Cerca gruppo Ares",
    Environment: "Ambiente",
    deselect: "Deseleziona tutto",
    "Select all": "Seleziona tutto",
    "No payload provided.": "Nessun payload fornito.",
    "Database name is required.": "Il nome del database è obbligatorio.",
    "Accounting company not found.": "La società contabile non è stata trovata.",
    "Accounting company Pantheon connection string is empty.":
        "La stringa di connessione Pantheon della società contabile è vuota.",
    "Selected Ares group does not belong to this accounting company.":
        "Il gruppo Ares selezionato non appartiene a questa società contabile.",
    "Ares group not found.": "Gruppo Ares non trovato.",
    "Ares group is required.": "Il gruppo Ares è obbligatorio.",
    "Ares service is not configured.": "Il servizio Ares non è configurato.",
    "Ares installation is already in progress for this company.":
        "L'installazione Ares è già in corso per questa azienda.",
    "No companies found for the given accounting company.":
        "Nessuna azienda trovata per la società contabile selezionata.",
    onixDmsBillingReport: "Report fatturazione DMS Onix",
    onixPhoneFunctionalityActivityReport: "Report attività funzionalità OnixPhone",
    byCompanyAndUser: "Per azienda e utente",
    totalActivity: "Attività totale",
    companyGroup: "Azienda",
    accountingCompanyGroup: "Società contabile",
    userGroup: "Utente",
    accountingCompany: "Società contabile",
    zbirno: "Zbirno",
    zbirnoRacunovodstvo: "Zbirno contabilità",
    onixPhoneDmsUsage: "Utilizzo DMS OnixPhone",
    dmsPantheonUsage: "Utilizzo DMS Pantheon",
    pantheonDocumentCount: "Numero documenti Pantheon",
    databaseCount: "Numero database",
    sourceIssues: "Problemi origine",
    message: "Messaggio",
    generatedOn: "Generato il",
    accountingUserId: "Utente contabile",
    activityCheckSqlHelpTitle: "Come funziona il controllo attività",
    activityCheckSqlHelp: "Eseguito sul DB Pantheon di ogni azienda. Restituisci 1 riga, 1 colonna; >0/true/non vuoto => attivo; 0/false/vuoto/nessuna riga => non attivo.",
    exportToCSV: "Esporta in CSV",
    exportToExcel: "Esporta in Excel",
    connection: "Connessione",
    documentType: "Tipo documento",
    sourceTable: "Tabella origine",
    counter: "Contatore",
    action: "Azione",
    summary: "Riepilogo",
    count: "Conteggio",
    records: "record",
    executionPhase: "Fase di esecuzione",
    executionPhaseOrder: "Ordine fase",
    Standard: "Standard",
    Bootstrap: "Bootstrap",
    SqlExecution: "Esecuzione SQL",
    TestRefreshSetup: "Preparazione refresh test",
    TestSuite: "Suite di test",
    TestTeardown: "Pulizia dopo i test",
    "unit-of-measure": "Unità di misura",
    "adding-marservis-material": "Aggiungi materiale",
    "editing-marservis-material": "Modifica materiale",
    "add-material": "Aggiungi materiale",
    "material-can-be-selected-once": "Un materiale può essere selezionato una sola volta.",
    "quantity-must-be-positive": "La quantità deve essere maggiore di zero.",
  "onix_web_app": "Onix Web",
  "portal_tickets_tile": "Ticket di assistenza",
  "portal_sign_in_title": "Accesso clienti",
  "portal_sign_in_intro": "Segui i tuoi ticket dell'assistenza Onix. Inserisci l'indirizzo e-mail con cui scrivi all'assistenza e ti invieremo un codice di accesso.",
  "portal_sign_in_open": "Accesso clienti (ticket)",
  "portal_email": "E-mail",
  "portal_email_invalid": "Inserisci un indirizzo e-mail valido.",
  "portal_send_code": "Invia codice",
  "portal_code": "Codice dall'e-mail",
  "portal_code_sent": "Se l'indirizzo è valido, abbiamo inviato un codice a sei cifre a {{email}}. È valido per 10 minuti.",
  "portal_verify_code": "Accedi",
  "portal_other_email": "Usa un altro indirizzo",
  "portal_consent_title": "Nuovo account cliente",
  "portal_consent_intro": "Non esiste ancora un account per {{email}}. L'account serve solo a seguire i tuoi ticket dell'assistenza Onix e puoi eliminarlo dal profilo.",
  "portal_consent_checkbox": "Acconsento all'apertura di un account e al trattamento del mio indirizzo e-mail e del mio nome per mostrare i ticket.",
  "portal_create_account": "Crea account",
  "portal_sign_in_failed": "Accesso non riuscito.",
  "team-viewer-script-token": "Token script TeamViewer",
  "team-viewer-script-token-description": "Token dal profilo TeamViewer (App). Richiede accesso in lettura a report delle connessioni, gruppi e dispositivi. Non scade, quindi non viene mai aggiornato.",
  "team-viewer-script-token-saved": "Token TeamViewer salvato.",
  "team-viewer-script-token-failed": "Salvataggio del token TeamViewer non riuscito.",
};
